import React, { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { FaGoogle, FaMailBulk } from 'react-icons/fa';

import Modal from './Modal';
import TextField from './TextField';
import { emailPasswordSignIn, signInWithGoogle } from '../Firebase/utils';
import { useAppDispatch } from '../store/store';
import { setUser } from '../store/features/UserSlice';
import { User } from '../types';

const SignUpWithEmailComponent = ({isSignInModalOpen, isSignUpModalOpen, setIsSignUpModalOpen, onClose}: {isSignInModalOpen: boolean, isSignUpModalOpen: boolean, setIsSignUpModalOpen: React.Dispatch<React.SetStateAction<boolean>>, onClose: () => void}) => {

  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string>('');
  const dispatch = useAppDispatch();

  const emailPasswordSignUpMutation = useMutation({
    mutationFn: async () => {

      if( email.trim() === '' || password.trim() === ''){
        throw new Error('Email and Password cannot be empty');
      }

      if (!email.includes('@')) {
        throw new Error('Invalid email address');
      }
      const user = await emailPasswordSignIn(email, password);
      return user;
    },
    onSuccess: (user) => {
      dispatch(setUser(user));
      onClose()
    },
    onError: (error) => {
      setError(error.message);
    }
  });

  const googleSignInMutation = useMutation({
    mutationFn: async () => {
      const user = await signInWithGoogle();
      return user;
    },
    onSuccess: (user) => {
      dispatch(setUser(user));
      onClose();
    },
    onError: (error) => {
      setError(error.message);
    }
  });

  return (
    <Modal title='Please Sign In' onClose={onClose} openState={isSignInModalOpen &&  !isSignUpModalOpen} left={'-left-5'}>
      <div className='flex flex-col gap-4'> 
        <TextField placeholder={'Enter your email'} inputValue={email} setInputValue={(value) => {setEmail(value)}}/>
        <TextField type='password' placeholder={'Password'} inputValue={password} setInputValue={(value) => {setPassword(value)}}/>
      </div>
      <p className='flex justify-end text-red-600 pt-2'>{error}</p>
      <button onClick={() => emailPasswordSignUpMutation.mutate()} className='flex flex-row gap-10 w-full items-center justify-center mt-10 py-2 text-lg md:text-xl uppercase font-SoulGaze tracking-wider text-slate-300 border border-slate-400 rounded-md'>
          <p className='flex gap-4 items-center text-[#3da8e2] font-BardotBold tracking-[0.25rem]'>Login</p>
      </button>
      <button onClick={() => googleSignInMutation.mutate()} className='flex flex-row gap-10 w-full items-center justify-center mt-10 py-2 text-lg md:text-xl uppercase font-SoulGaze tracking-wider text-slate-300 border border-slate-400 rounded-md'>
          <p className='flex gap-4 items-center text-[#3da8e2] font-BardotBold tracking-[0.25rem]'><FaGoogle className='text-2xl'/>Signin With Google</p>
      </button>
      <p className="flex justify-end pt-4">Don't have an account?<span onClick={() => setIsSignUpModalOpen(true)} className='text-[#3da8e2] pl-2 hover:cursor-pointer'>Create Account</span></p>
  </Modal>
  );
}

export default SignUpWithEmailComponent